import React from 'react';
import { CircularProgress } from '@mui/material';

const Loader = () => {
  return (
      <CircularProgress  size={20}  sx={{color:"white"}} />
  );
};

export default Loader;